<template>
  <div id="player">
    <div class="black">
      <span @click="close" style="color: #fff"><i class="el-icon-close" style="color: #fff"></i></span>
    </div>
    <video id="video" ref="video" autoplay  :src="url"  controls="true" preload="auto" webkit-playsinline="true" playsinline="true"
      x-webkit-airplay="allow" x5-video-player-type="h5" x5-video-player-fullscreen="true"
      x5-video-orientation="landscape" width="100%" height="100%"></video>
    <!-- 
      
       id="video" 
      src="video.mp4" /*视频地址*/
      controls = "true" /*是否显示播放控件*/
      poster="images.jpg" /*视频封面*/
      preload="auto" /*预加载*/
      webkit-playsinline="true" /*IOS中让视频在小窗内播放而不是全屏播放*/  
      playsinline="true" /*IOS微信浏览器支持小窗内播放*/ 
      x-webkit-airplay="allow" /*是否支持ios的AirPlay功能*/
      x5-video-player-type="h5" /*启用H5播放器,是wechat安卓版特性*/
      x5-video-player-fullscreen="true" /*设置为true防止横屏*/
      x5-video-orientation="portraint" /*播放器的方向，landscape横屏，portraint竖屏，默认值为竖屏*/
     -->
  </div>
</template>

<script>
// 在组件中引入
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  name: "openvideo",
  components: {},
  data() {
    return {
      // url: "",
    };
  },
  mounted() {
    // if (this.$route.params.url) {
    //   this.url = this.$route.params.url;
    // }
  },
  beforeDestroy() {

  },
  methods: {
    close() {
      this.$refs.video.pause()
      this.$emit('closevide')
    },
  },
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;
}

#player {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 1);
}

.black {
  font-size: 1.5625rem;
  color: #fff;
  position: fixed;
  right: 7%;
  margin-top: 5px;
  transform: translateX(-50%);
  z-index: 9999;
}

#video {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
